import { render, staticRenderFns } from "./user-profile-tab.vue?vue&type=template&id=3d2ddcf5&scoped=true&"
import script from "./user-profile-tab.vue?vue&type=script&lang=ts&"
export * from "./user-profile-tab.vue?vue&type=script&lang=ts&"
import style0 from "./user-profile-tab.vue?vue&type=style&index=0&id=3d2ddcf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2ddcf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
